module.exports = "https://static.wmbcdn.com/uniweb/images/f66f541a92f0c7a4768c011f8404855a.svg";